import { createRouter, createWebHashHistory } from 'vue-router'

// 正确导入移动端组件（路径改为实际位置）
import MobileLayout from '../vives/H5yidong/zhuye/MobileLayout.vue'; // 移动端布局
import MobileHome from '../vives/H5yidong/zhuye/hahah/MobileHome.vue'; // 移动端首页
import MobileChat from '../vives/H5yidong/zhuye/hahah/MobileChat.vue'; // 移动端沟通页
import MobileTalent from '../vives/H5yidong/zhuye/hahah/MobileTalent.vue'; // 移动端找人才页
import MobileInterview from '../vives/H5yidong/zhuye/hahah/MobileInterview.vue'; // 移动端面试邀请页
import MobileMine from '../vives/H5yidong/zhuye/hahah/MobileMine.vue'; // 移动端我的页
import StoreStaffRanking from '@/vives/StoreStaffRanking.vue'
// 引入新增到店记录和跟进记录组件（需自行创建）


//订单页
import Dingdan from '../vives/dingdan/h5.vue';


import AddDaodian from '../vives/H5yidong/zhuye/components/AddDaodian.vue'
import FollowRecord from '../vives/H5yidong/zhuye/components/FollowRecord.vue'
import List from '../list/index.vue'


const routes = [
  {
    path: '',
    name: 'login',
    component: () => import( '../vives/login/login.vue') // PC 端登录页
  },
      {
    path: '/pass',
    name: '错误',
    component: () => import( '../vives/login/UnnamedTip.vue') // 未命名返回界面
  },
  {
    path: '/login',
    name: 'H5登录',
    component: () => import( '../vives/H5yidong/LoginMobile.vue') // 移动端登录页
  },
      // 移动端布局路由（嵌套路由的父路由）
  {
    path: '/mobile',
    component: MobileLayout,
    children: [
      { path: 'home', component: MobileHome }, // 首页
      { path: 'chat', component: MobileChat }, // 沟通页
      { path: 'talent', component: MobileTalent,name:'ShiPin' }, // 找人才页
      { path: 'interview', component: MobileInterview }, // 面试邀请页
      { path: 'mine', component: MobileMine }, // 我的页


        { path: 'dingdan', component: Dingdan },


         { path: 'daodian/add', component: AddDaodian, name: 'AddDaodian' },
        // 跟进记录路由，动态接收 daodianId 参数
        { path: 'daodian/follow', component: FollowRecord, name: 'FollowRecord' },
      { path: '', redirect: 'home' }, // 默认跳转到首页
         { path: 'list', component: List }, // 筛选之后的列表
    ],
  },

  {
    path: '/zhuce',
    name: 'zhuce',
    component: () => import( '../vives/login/zhuce.vue')
  },
  {
    path: '/home',
    name: '橙子阿姨管理系统',
    component: () => import( '../vives/zhuye/index.vue'),
    redirect: '/index',
    children:[
                    {
            path: '/index',
            name: '首页',
            component: () => import( '../vives/caidan/index.vue')
          },
             {
            path: '/caidan',
            name: '菜单管理',
            component: () => import( '../vives/caidan/caidan.vue')
          },
        {
            path: '/mendian',
            name: '门店管理',
            component: () => import( '../vives/caidan/mendian.vue')
          },
              {
            path: '/fenlei',
            name: '分类管理',
            component: () => import( '../vives/caidan/fenlei.vue')
          },
              {
            path: '/yuangong',
            name: '员工管理',
            component: () => import( '../vives/caidan/yuangong.vue')
          },

              {
            path: '/gongshi',
            name: '图片管理',
            component: () => import( '../vives/caidan/gongshi.vue')
          },
                      {
            path: '/geren',
            name: '个人中心',
            component: () => import( '../vives/gerenziliao/index.vue')
          },
                              {
            path: '/juese',
            name: '权限管理',
            component: () => import( '../vives/caidan/quanxian.vue')
          },
                                      {
            path: '/daodian',
            name: '到店跟进',
            component: () => import( '../vives/caidan/daodian.vue')
          },
                                      {
            path: '/yeji',
            name: '业绩排名',
            component: () => import( '../vives/caidan/yeji.vue')
          },
        {
            path: '/video',
            name: '视频管理',
            component: () => import( '../vives/caidan/videos.vue')
          },
           {
            path: '/courses',
            name: '网课列表',
            component: () => import( '../vives/wangke/CourseList.vue')
          },
                   {
            path: '/courses/create',
            name: 'CourseCreate',
            component: () => import( '../vives/wangke/CourseForm.vue')
          },
                   {
            path: '/courses/:id/edit',
            name: 'CourseEdit',
            component: () => import( '../vives/wangke/CourseForm.vue')
          },
                   {
            path: '/courses/:id',
            name: 'CourseDetail',
            component: () => import( '../vives/wangke/CourseDetail.vue')
          },








        {
            path: '/chengshi/',
            name: '城市管理',
            component: () => import( '../vives/ayi/chengshi/index.vue')
          },
         {
            path: '/ayi/leixing',
            name: '工种管理',
            component: () => import( '../vives/ayi/gongzhong/index.vue')
          },
        {
            path: '/ayi/ayi',
            name: '阿姨列表',
            component: () => import( '../vives/ayi/user/index.vue')
          },
        {
            path: '/ayi/zhuangtai',
            name: '状态管理',
            component: () => import( '../vives/ayi/zhuangtai/index.vue')
          },
         {
            path: '/ayi/biaoti',
            name: '标题管理',
            component: () => import( '../vives/zhuangxiu/NavConfigManage.vue')
          },
                 {
            path: '/component/list',
            name: '组件管理',
            component: () => import( '../vives/zhuangxiu/zujian/zujianlist.vue')
          },
        {
            path: '/component/edit/:id?',
            name: '组件配置',
            component: () => import( '../vives/zhuangxiu/zujian/zujianapp.vue')
          },
             {
                    path: '/kaoshi/',
                    name: '考试管理',
                    component: () => import('@/vives/kaoshi/index.vue'),
                    children: [
                      {
                        path: 'fenlei/',
                        name: '题目分类',
                        component: () => import('@/vives/kaoshi/fenlei.vue'),
                      },
                      {
                        path: 'timu/',
                        name: '试题管理',
                        component: () => import('@/vives/kaoshi/timu.vue'),
                      },

                    ]
                  },
        {
            path: '/ppt/',
            name: '模拟考试首页',
            component: () => import( '@/vives/kaoshi/moni/index.vue'),
          },
                                                                                              {
            path: '/dati/',
            name: '答题界面',
            component: () => import( '@/vives/kaoshi/moni/dati.vue'),
          },
                                                                                                      {
            path: '/jieguo/',
            name: '考试结果页面',
            component: () => import( '@/vives/kaoshi/moni/jieguo.vue'),
          },
        {
            path: '/dating/',
            name: '大厅管理',
            component: () => import( '@/vives/zhuangxiu/dating/index.vue'),
          },
           {
            path: '/ditu/key',
            name: '腾讯地图key',
            component: () => import( '@/vives/peizhi/tengxun.vue'),
          },
         {
            path: '/kaoshi/leimu',
            name: '考试类目',
            component: () => import( '@/vives/kaoshi/kaoshileimu.vue'),
          },
         {
            path: '/kaoshi/shiti',
            name: '考试题目',
            component: () => import( '@/vives/kaoshi/shijuan.vue'),
          },
                 {
            path: '/kaoshi/jilu',
            name: '报名详情',
            component: () => import( '@/vives/kaoshi/kaoshijilu.vue'),
          },
        {
            path: '/kaoshi/list',
            name: '考试名单',
            component: () => import( '@/vives/kaoshi/kaoshilist.vue'),
          },
        {
            path: '/kaoshi/xiangqiang',
            name: '考试详情',
            component: () => import( '@/vives/kaoshi/kaoshixiangqing.vue'),
          },
        {
            path: '/wangke/fenlei',
            name: '网课分类',
            component: () => import( '@/vives/wangkeayi/leimu.vue'),
          },
        {
            path: '/wangke/leimu',
            name: '网课管理',
            component: () => import( '@/vives/wangkeayi/kecheng.vue'),
          },
        {
            path: '/wangke/mulu',
            name: '网课目录',
            component: () => import( '@/vives/wangkeayi/mulu.vue'),
          },
        {
            path: '/dingdan/list',
            name: '订单列表',
            component: () => import( '@/vives/dingdan/index.vue'),
          },


















                           {
            path: '/imgaa',
            name: '群发500人',
            component: () => import( '../vives/caidan/img500.vue')
          },
        // 新增：门店员工排名路由（携带门店ID和名称参数）
          {
            path: '/store-staff-ranking',
            name: 'StoreStaffRanking',
            component: StoreStaffRanking,
            props: route => ({
              storeId: route.query.storeId, // 门店ID（推荐用ID，避免名称重复）
              storeName: route.query.storeName // 门店名称（用于页面标题）
            })
          },
  // 其他路由





    ]
  },

]

const router = createRouter({
  history: createWebHashHistory(),
  routes

})

export default router;